// import { useForm } from "@mantine/form";
import { useMutation } from "@tanstack/react-query";
import { updateTypeOfMonths } from "../../../../../api/agencyAdmin/bonus";
import { useNavigate } from "react-router-dom";
import { notifications } from "@mantine/notifications";
import { successNotification } from "../../../../../utility/notification";
import { useQueryClient } from '@tanstack/react-query';

const useCreate = (queryKey) => {
    const navigate = useNavigate()
    const queryclient = useQueryClient()
    const createMutation = useMutation({
        mutationFn: updateTypeOfMonths,
        onSuccess: async (response) => {
            try {

                await queryclient.invalidateQueries({
                    queryKey
                })

                successNotification({
                    message: response?.message
                });

            } catch (error) {

            }
        }
    })

    return { createMutation }

}

export default useCreate;
